import { PitchUsageHoursResponse } from '@intelligent-play-v2/domain';
import { FilteredStatisticsParams } from '~/types';
import { queryBuilder } from '~/api';

export const getUsageHours = async ({
  pitchIds,
  timePeriod,
  from,
  to,
  timezone,
  dailyStartTime,
  dailyEndTime,
  includedDays,
}: FilteredStatisticsParams): Promise<PitchUsageHoursResponse[]> => {
  const { data } = await queryBuilder('GET', 'stats/usageHours', {
    timePeriod,
    from,
    to,
    pitchIds: pitchIds.join(','),
    timezone,
    dailyStartTime,
    dailyEndTime,
    includedDays: includedDays?.join(','),
  });
  return data;
};
